import { baseBrandConfig } from '../brand';
/**
 * Movant — "litigation support that moves first". Values come from the brand
 * kit's token file (`movant-tokens.json`, light theme) through the mapping its
 * guidelines give from the settings keys to the tokens:
 *
 *   primary / primaryHover          signal / signal-hover
 *   primaryLight                    signal-tint (highlights)
 *   bgAccent                        info-tint (info banners)
 *   secondary, bgDark               ink            secondaryLight   ink-2
 *   text / textLight / textMuted    text / text-secondary / text-muted
 *   bgLight / bgWhite, bgCard       paper / surface
 *   border / borderDark             border / border-strong
 *   primaryAction                   signal (the green call to action is retired)
 *   sidebar*                        the kit's one sidebar set
 *   onPrimary                       on-signal — never white on signal
 *   link                            link (ink; signal is a fill, never text)
 */
export const movantBrand = {
    ...baseBrandConfig,
    company: {
        name: 'Movant',
        shortName: 'Movant',
        tagline: 'Move first.',
        description: 'Litigation support for California firms: eFiling, process serving and court services.',
    },
    // No phone line, office address or hours have been published for Movant; the
    // surfaces that show contact details show the support address alone.
    contact: {
        phone: { primary: '', secondary: '', fax: '' },
        hours: '',
        addresses: {},
    },
    app: {
        version: '7.0.6716',
        copyright: 'Movant',
        year: '2026',
    },
    colors: {
        primary: '#FF5A36',
        primaryHover: '#E8492A',
        primaryLight: '#FFE9E3',
        secondary: '#0E1B2C',
        secondaryLight: '#1B2A3F',
        text: '#1F2A37',
        textLight: '#5B6B7F',
        textMuted: '#8A96A6',
        bgWhite: '#FFFFFF',
        bgLight: '#F6F4EF',
        bgCard: '#FFFFFF',
        bgAccent: '#E6EEFA',
        bgDark: '#0E1B2C',
        border: '#E4E1D8',
        borderDark: '#8C8576',
        success: '#1E7A4F',
        warning: '#A15C07',
        error: '#B42318',
        info: '#2F5DA8',
        sidebarBg: '#0E1B2C',
        sidebarText: '#D5DCE6',
        sidebarActive: '#FF5A36',
        sidebarHover: '#1B2A3F',
        primaryAction: '#FF5A36',
        onPrimary: '#0E1B2C',
        link: '#0E1B2C',
    },
    typography: {
        fontFamily: {
            heading: 'Manrope, system-ui, -apple-system, sans-serif',
            body: 'Manrope, system-ui, -apple-system, sans-serif',
            mono: '"JetBrains Mono", ui-monospace, monospace',
        },
    },
    logos: {
        primary: '/brand/movant/movant-lockup.svg',
        icon: '/brand/movant/movant-mark.svg',
        dark: '/brand/movant/movant-lockup-reverse.svg',
        iconDark: '/brand/movant/movant-mark-reverse.svg',
    },
    document: {
        title: 'Movant',
        description: 'Movant - Litigation support for California firms: eFiling, process serving and court services.',
        themeColor: '#0E1B2C',
        favicon: '/brand/movant/favicon.ico',
        appleTouchIcon: '/brand/movant/apple-touch-icon-180.png',
        manifest: '/brand/movant/manifest.json',
        fontsHref: 'https://fonts.googleapis.com/css2?family=Manrope:wght@500;700;800&family=JetBrains+Mono:wght@500&display=swap',
    },
    // Sentence case, per the brand guidelines — the two sidebar labels the kit
    // names. The rest of the app's wording moves in its own pass.
    navigation: {
        ...baseBrandConfig.navigation,
        sidebar: baseBrandConfig.navigation.sidebar.map((item) => item.id === 'placeOrder'
            ? { ...item, label: 'Place new order' }
            : item.id === 'pending'
                ? { ...item, label: 'Pending submission' }
                : item),
    },
};
